import React, { FunctionComponent, ReactElement } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../../utils/PropTypesDefinitions'

export type MoreIconProps = TestID

const MoreIcon: FunctionComponent<MoreIconProps> = ({ testID = 'more-icon' }): ReactElement => (
    <Grid
        noExpand
        center
        width={18}
        height={18}
        borderRadius={9}
        backgroundColor="moon-2"
        testID={testID}
    >
        <FontelloIcon name="more-tab-active" color="onyx" fontSize={3} />
    </Grid>
)

export default MoreIcon
